
const parser = require('xml-js')

module.exports = {
    toJs: txt => parser.xml2js(txt, {compact: true}),
    toJson: txt => parser.xml2json(txt, {compact: true})
}